import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEllipse = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 4,
	height: 4,
	viewBox: "0 0 4 4",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 2,
		cy: 2,
		r: 2,
		fill: "#D9DEEB"
	})
});
const ForwardRef = forwardRef(SvgEllipse);
export default ForwardRef;
